import * as React from 'react';
import CDRForm from './CDR';
import CERADForm from './CERAD';
import MMSEForm from './MMSE';
import MOCAForm from './MOCA';
import SDMTForm from './SDMT';
import TMTForm from './TMT';

import type { TCognitionDocumentType, TRelevantDocumentType } from '../../utils';

const CognitionForm = ({ documents, formData, document, viewing = false }: IOwnProps): React.JSX.Element | null => {
  switch (document?._type) {
    case 'moca':
      return <MOCAForm formData={formData} viewing={viewing} />;
    case 'mmse':
      return <MMSEForm formData={formData} viewing={viewing} />;
    case 'tmt':
      return <TMTForm formData={formData} viewing={viewing} />;
    case 'sdmt':
      return <SDMTForm formData={formData} viewing={viewing} />;
    case 'cdr':
      return <CDRForm formData={formData} viewing={viewing} />;
    case 'cerad':
      return <CERADForm documents={documents} formData={formData} viewing={viewing} />;
    default:
      return null;
  }
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<TRelevantDocumentType>>;
  formData: IFormData;
  document?: IDocumentWithTypeV2<TCognitionDocumentType>;
  viewing?: boolean;
}

export default CognitionForm;
